import { Box, Skeleton, styled, useMediaQuery, useTheme } from "@mui/material";
import React, { useState } from "react";
import { useChat } from "../../../context";
import { InfoPanelProps } from "../../../interfaces/all";
import ContactInfoSidebar from "./ContactInfoSidebar";
import SearchSidebar from "./SearchSidebar";

const PanelContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$isOpen" && prop !== "$isSmallScreen",
})<{ $isOpen: boolean; $isSmallScreen: boolean }>(({ $isOpen }) => ({
  width: "100%",
  height: "100%",
  backgroundColor: "#ffffff",
  borderLeft: "1px solid #e9edef",
  display: "flex",
  flexDirection: "column",
  transform: $isOpen ? "translateX(0)" : "translateX(100%)",
  transition: "transform 0.3s ease",
  zIndex: 1000,
  flex: 1,
  minWidth: 0,
  overflow: "hidden",
}));

const InfoPanel: React.FC<InfoPanelProps> = ({
  isOpen,
  onClose,
  type = "search",
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down(1366));
  const { selectedConversation } = useChat();
  const [loading, setLoading] = useState(false);

  if (!isOpen || !selectedConversation) return null;

  if (loading) {
    return (
      <Box
        sx={{
          width: "30%",
          minWidth: "400px",
          maxWidth: "400px",
          height: "100%",
          backgroundColor: "#ffffff",
          borderLeft: "1px solid #e9edef",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            height: "60px",
            display: "flex",
            alignItems: "center",
            padding: "0 16px",
            borderBottom: "1px solid #e9edef",
            backgroundColor: "#f0f2f5",
          }}
        >
          <Skeleton variant="text" width="60%" height={24} />
        </Box>
        <Box sx={{ flex: 1, p: 2 }}>
          <Skeleton
            variant="rectangular"
            width="100%"
            height={40}
            sx={{ mb: 2 }}
          />
          {Array.from({ length: 5 }).map((_, index) => (
            <Box key={`info-panel-skeleton-${index}`} sx={{ mb: 2 }}>
              <Skeleton variant="text" width="80%" height={20} />
              <Skeleton variant="text" width="60%" height={16} />
            </Box>
          ))}
        </Box>
      </Box>
    );
  }

  const renderSidebar = () => {
    switch (type) {
      case "search":
        return <SearchSidebar isOpen={isOpen} onClose={onClose} />;
      case "contact":
        return <ContactInfoSidebar isOpen={isOpen} onClose={onClose} />;
      default:
        return <SearchSidebar isOpen={isOpen} onClose={onClose} />;
    }
  };

  return (
    <PanelContainer $isOpen={isOpen} $isSmallScreen={isSmallScreen}>
      {renderSidebar()}
    </PanelContainer>
  );
};

export default InfoPanel;
